module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reject-document"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('rejectDocument.rejectWarning')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('rejectDocument.areYouSure')))]), _vm._v(" "), _c('div', {
    staticClass: "reject-document__reason"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('rejectDocument.reason')))]), _vm._v(" "), _c('textarea', {
    ref: "reason"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5a11804","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RejectDocument.vue
// module id = 1064
// module chunks = 1